import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=67de56d5&scoped=true&"
import script from "./commodity.vue?vue&type=script&lang=js&"
export * from "./commodity.vue?vue&type=script&lang=js&"
import style0 from "./commodity.vue?vue&type=style&index=0&id=67de56d5&prod&lang=less&scoped=true&"
import style1 from "./commodity.vue?vue&type=style&index=1&id=67de56d5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de56d5",
  null
  
)

export default component.exports